<div class="container mx-auto px-5 py-10">
  <div class="w-full mb-5">
    <img class="w-full" src="../assets/leaflet1.jpg" alt="manual 1" />
  </div>
  <div class="w-full">
    <img class="w-full" src="../assets/leaflet2.jpg" alt="manual 2" />
  </div>
</div>
